import React, {Component} from 'react';
import Styles from './style.css';
import cx from "classnames";
const queryString = require('query-string');


class TemplateVideoBasic extends Component {

    constructor(props) {
        super(props);
        this.state = {
            industry: "",
            industry_image: "",
            slider_image: "",
            slider_text: "",
            location: "",
            price: "",
            error: false
        };
    };

    componentWillMount() {
        try {
            let url = window.location.search;
            let data = queryString.parse(url);
            this.setState({
                industry: data.industry,
                industry_image: data.industry_image,
                slidesAmount: +data.slidesAmount,
                slides: JSON.parse(data.slides),
                location: data.location,
                price: data.price
            }, () => {
                console.log(this.state.slides);
            })
        }catch (e) {
            this.setState({
                error: true
            });
            console.log(e);
        }
    }

    render() {
        return(
            <div className={Styles.container}>
                {
                    this.state.slidesAmount === 1 &&
                    <div className={Styles.container}>
                        <div className={cx(Styles.First, Styles.OneAnimationFirst)}>
                            <div className={Styles.FirstInner}/>
                            <div className={Styles.FirstInnerOverlay}>
                                <div className={Styles.FirstInnerOverlayTitle}>
                                    {this.state.industry}
                                </div>
                                <div className={Styles.FirstInnerOverlaySubtitle}>
                                    {this.state.location}
                                </div>
                            </div>
                        </div>
                        {
                            this.state.slides.map((item) => {
                                return(
                                    <div className={cx(Styles.Slide, Styles.OneAnimationSecond)}>
                                        <div style={{backgroundImage: 'url('+item.image+')'}} className={Styles.SlideInner}>
                                            <div className={Styles.SlideInnerTextBox}>
                                                {item.title}
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                        <div className={cx(Styles.Last, Styles.OneAnimationThird)}>
                            <div className={Styles.LastTitle}>
                                {this.state.price}
                            </div>
                            <div className={Styles.LastSubtitle}>
                                {"Learn more"}
                            </div>
                        </div>
                    </div>
                }
                {
                    this.state.slidesAmount === 2 &&
                    <div className={Styles.container}>
                        <div className={cx(Styles.First, Styles.TwoAnimationFirst)}>
                            <div style={{backgroundImage: 'url('+this.state.industry_image+')'}} className={Styles.FirstInner}/>
                            <div className={Styles.FirstInnerOverlay}>
                                <div className={Styles.FirstInnerOverlayTitle}>
                                    {this.state.industry}
                                </div>
                                <div className={Styles.FirstInnerOverlaySubtitle}>
                                    {this.state.location}
                                </div>
                            </div>
                        </div>
                        {
                            this.state.slides.map((item, index) => {
                                return(
                                    <div className={
                                        cx(Styles.Slide,
                                            {
                                                [Styles.TwoAnimationSecond]: index === 0,
                                                [Styles.TwoAnimationThird]: index === 1,
                                            })
                                    }>
                                        <div style={{backgroundImage: 'url('+item.image+')'}} className={Styles.SlideInner}>
                                            <div className={Styles.SlideInnerTextBox}>
                                                {item.title}
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                        <div className={cx(Styles.Last, Styles.TwoAnimationFourth)}>
                            <div className={Styles.LastTitle}>
                                {this.state.price}
                            </div>
                            <div className={Styles.LastSubtitle}>
                                {"Learn more"}
                            </div>
                        </div>
                    </div>
                }
                {
                    this.state.slidesAmount === 3 &&
                    <div className={Styles.container}>
                        <div className={cx(Styles.First, Styles.ThreeAnimationFirst)}>
                            <div style={{backgroundImage: 'url('+this.state.industry_image+')'}} className={Styles.FirstInner}/>
                            <div className={Styles.FirstInnerOverlay}>
                                <div className={Styles.FirstInnerOverlayTitle}>
                                    {this.state.industry}
                                </div>
                                <div className={Styles.FirstInnerOverlaySubtitle}>
                                    {this.state.location}
                                </div>
                            </div>
                        </div>
                        {
                            this.state.slides.map((item, index) => {
                                return(
                                    <div className={
                                        cx(Styles.Slide,
                                            {
                                                [Styles.ThreeAnimationSecond]: index === 0,
                                                [Styles.ThreeAnimationThird]: index === 1,
                                                [Styles.ThreeAnimationFourth]: index === 2,
                                            })
                                    }>
                                        <div style={{backgroundImage: 'url('+item.image+')'}} className={Styles.SlideInner}>
                                            <div className={Styles.SlideInnerTextBox}>
                                                {item.title}
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                        <div className={cx(Styles.Last, Styles.ThreeAnimationFifth)}>
                            <div className={Styles.LastTitle}>
                                {this.state.price}
                            </div>
                            <div className={Styles.LastSubtitle}>
                                {"Learn more"}
                            </div>
                        </div>
                    </div>
                }
                {
                    this.state.slidesAmount === 4 &&
                    <div className={Styles.container}>
                        <div className={cx(Styles.First, Styles.FourAnimationFirst)}>
                            <div style={{backgroundImage: 'url('+this.state.industry_image+')'}} className={Styles.FirstInner}/>
                            <div className={Styles.FirstInnerOverlay}>
                                <div className={Styles.FirstInnerOverlayTitle}>
                                    {this.state.industry}
                                </div>
                                <div className={Styles.FirstInnerOverlaySubtitle}>
                                    {this.state.location}
                                </div>
                            </div>
                        </div>
                        {
                            this.state.slides.map((item, index) => {
                                return(
                                    <div className={
                                        cx(Styles.Slide,
                                            {
                                                [Styles.FourAnimationSecond]: index === 0,
                                                [Styles.FourAnimationThird]: index === 1,
                                                [Styles.FourAnimationFourth]: index === 2,
                                                [Styles.FourAnimationFourth]: index === 3,
                                            })
                                    }>
                                        <div style={{backgroundImage: 'url('+item.image+')'}} className={Styles.SlideInner}>
                                            <div className={Styles.SlideInnerTextBox}>
                                                {item.title}
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                        <div className={cx(Styles.Last, Styles.FourAnimationFifth)}>
                            <div className={Styles.LastTitle}>
                                {this.state.price}
                            </div>
                            <div className={Styles.LastSubtitle}>
                                {"Learn more"}
                            </div>
                        </div>
                    </div>
                }
            </div>
        )
    }
}

export default TemplateVideoBasic;


// WEBPACK FOOTER //
// ./src/templates/videos/basic/component.js